/**
 * Incentivo por tiempo limitado.
 *
 * Es un REGALO con fecha, no una rebaja: quien reserva antes de `HASTA` se
 * lleva algo más por el mismo precio. La diferencia importa. Un descuento
 * atrae a quien viene por el precio y enseña a esperar la próxima oferta; un
 * regalo con fecha le da un motivo para decidir hoy a quien ya quería
 * reservar, sin tocar lo que se cobra.
 *
 * SE APAGA SOLO. Pasada la fecha, el aviso desaparece de todas las páginas sin
 * que nadie tenga que acordarse de sacarlo. Un incentivo vencido todavía
 * publicado es la señal más clara de un sitio abandonado.
 *
 * PARA CAMBIARLO: `HASTA` y `regalo`. Para apagarlo, deja `HASTA` en "".
 */

/** Último día en que el regalo vale, inclusive. Formato YYYY-MM-DD. */
export const HASTA = "2026-10-31";

/** Hoy en Chile, en YYYY-MM-DD. No sirve el UTC: adelanta el corte varias horas. */
const hoyEnChile = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Santiago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());

export const incentivoActivo = () => Boolean(HASTA) && hoyEnChile() <= HASTA;

/** "31 de octubre", para el copy. */
export const hastaTexto = () =>
  new Intl.DateTimeFormat("es-CL", {
    timeZone: "America/Santiago",
    day: "numeric",
    month: "long",
  }).format(new Date(`${HASTA}T12:00:00Z`));

export const INCENTIVO = {
  regalo: "5 fotos editadas extra de regalo",
  /* Se arma en una función para que la fecha salga siempre de HASTA. */
  frase: () => `Reserva tu fecha antes del ${hastaTexto()} y te llevas 5 fotos editadas extra de regalo.`,
  condicion: "Vale para cualquier pack, al confirmar la reserva.",
};
